/*
# -----------------------------------------------------------------------------
# Component: index.js
# Author: antonio.ramirez@pst.sg
# Created Date: 14/May/2019
# Comments: Responsible for the state management of Manage Receipts
# -----------------------------------------------------------------------------
*/
import clone from 'clone'
import { actions } from './actions'
import { getters } from './getters/getters'
import { mutations } from './mutations'

export const initialState = {
  // Agency level init (bring in menu for specific modules eg: travel motor etc)
  // 0: Loading, 1: Success, 2: Fail
  init: 0,
  initErr: [],
  menu: {},
  receiptListing: {
    init: 0,
    initErr: [],
    menu: {}
  },
  receiptData: {
    branch: '',
    acctNo: '',
    type: '',
    docNo: '',
    fund: '',
    suffix: '',
    tranMode: ''
  }
}

export default {
  state: clone(initialState),
  getters,
  mutations,
  actions
}
